export enum Timezone {
	UtcPlus1 = 1,
	UtcMinus4 = 2,
	UtcMinus3 = 3,
	UtcMinus5 = 4,
	UtcPlus4 = 5,
	UtcPlus11 = 6
}
